// MainLayout.jsx
import { Head } from 'components/Head';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from 'assets/logo.png';

export const AccountLayout = ({ title, description, children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      {/* Meta Information */}
      <Head title={title} description={description} />
      <div className="flex flex-col items-center my-8">
        <Link to="/" className="flex items-center gap-2 mb-12">
          <img src={logo} className="h-6" />
        </Link>
        <div className="rounded-full bg-black p-2 text-white w-fit px-4 text-sm font-semibold">
          Buy. Sell. Nearby
        </div>
        <div className="my-4 flex flex-col items-center justify-center">
          <div className="font-semibold">{title}</div>
          <div className="text-sm text-gray-700 font-light">{description}</div>
        </div>
        <main className="w-full px-12 md:w-4/12">{children}</main>
        <div className="text-xs mt-12">
          By continuing, you agree to our{' '}
          <Link to="/terms" className="underline font-semibold">
            Terms
          </Link>{' '}
          &{' '}
          <Link to="/privacy" className="underline font-semibold">
            Privacy Policy
          </Link>
        </div>
      </div>
    </>
  );
};
